<div class="card">
  <div class="card-body">
    @if (loading) {
      <div class="widget-loading"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span>Loading report…</div>
    } @else if (error) {
      <div class="widget-error" role="alert">{{ error }}</div>
    } @else {
      <div class="d-flex align-items-center gap-2 w-100">
        <div class="metric-content">
          <h4 class="subheader mb-0 text-truncate" [title]="label">{{ label }}</h4>
          <div class="metric-line d-flex align-items-baseline gap-2">
            <span class="h3 m-0 metric-value">{{ value }}</span>
            @if (subtextValue || subtext) { <span class="text-secondary small metric-support text-truncate" [title]="(subtextValue + ' ' + subtext).trim()">{{ subtextValue }} {{ subtext }}</span> }
          </div>
        </div>
        <span class="avatar avatar-lg flex-shrink-0">
            <app-dashboard-icon [svg]="iconSvg">@switch (icon) {
              @case ('money') { <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -8"></path><path d="M3 10l18 0M7 15l.01 0M11 15l2 0"></path></svg> }
              @case ('orders') { <svg viewBox="0 0 24 24"><path d="M7 4h10l2 4v12H5V8zM5 8h14M9 12h6"></path></svg> }
              @case ('users') { <svg viewBox="0 0 24 24"><path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M3 21v-2a6 6 0 0 1 12 0v2M16 3.5a4 4 0 0 1 0 7M17 14a6 6 0 0 1 4 5v2"></path></svg> }
              @case ('briefcase') { <svg viewBox="0 0 24 24"><path d="M3 7h18v13H3zM8 7V4h8v3M3 12h18M10 12v2h4v-2"></path></svg> }
              @case ('percentage') { <svg viewBox="0 0 24 24"><path d="M17 7 7 17M7.5 7h.01M16.5 17h.01"></path></svg> }
              @case ('trend') { <svg viewBox="0 0 24 24"><path d="M4 19V9l5 4 5-8 6 4"></path></svg> }
              @default { <svg viewBox="0 0 24 24"><path d="M16.7 8A3 3 0 0 0 14 6h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1-2.7-2M12 3v3m0 12v3"></path></svg> }
            }</app-dashboard-icon>
        </span>
      </div>
    }
  </div>
</div>
